var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPenPaper = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pen-paper-a",
    d: "M63.8492432,8.15132519 C67.3053192,11.60737 66.0618898,13.9598986 63.8492432,16.1761894 L61.1748947,18.8505138 L53.1481849,10.8256495 L55.8225334,8.15132519 C58.0387261,5.93692553 60.3931672,4.69528036 63.8492432,8.15132519 Z M26.7561708,37.2209441 L24.0837135,47.9182415 L34.7811075,45.2439172 L58.5005462,21.5247199 L50.4738365,13.4998557 L26.7561708,37.2209441 Z M51.3900473,33.9855672 L51.3900473,58.4349791 L13.5650079,58.4349791 L13.5650079,20.6102813 L38.0164136,20.6102813 L45.579412,13.0453417 L6,13.0453417 L6,65.9999187 L58.9550552,65.9999187 L58.9550552,26.4187364 L51.3900473,33.9855672 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pen-paper-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPenPaper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pen-paper.0e0c263ee63f5e2d9a4f94f9397f9009.svg";